import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';

const SellerPage = lazy(() => import('~/pages/SellerAnalytics'));

export const SELLER_ANALYTICS_ROUTES: RouteObject[] = [
  {
    path: ':detailPageType?/:id?/:subPageType?',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <SellerPage />
      </Suspense>
    ),
  },
];
